var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('button',{staticClass:"pull-right btn btn-fill btn-info btn-wd btn-danger",on:{"click":_vm.resetIndex}},[_vm._v("Clear Data")]),_c('div',{staticClass:"clearfix"})]),_c('Pivot',{ref:"pivot",attrs:{"toolbar":"","height":_vm.tableHeight(250),"report":{
      dataSource: {
        type: 'api',
        url: _vm.flexmonsterDataServerUrl,
        index: _vm.indexName,
        mapping: _vm.mapping,
        requestHeaders: _vm.requestHeaders
      }
    },"beforetoolbarcreated":_vm.customizeToolbar,"_v-bind:licenseKey":"'XXXX-TODO-ADD-TO-CONFIGS-COLLECTION-IN-MONGO-XXXX'"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }